// extracted by mini-css-extract-plugin
module.exports = {"root":"search-autocomplete-menu-error-message_root__yrKBW"};